import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import Profile from "../profile/Profile";
import './Navigation.css';

const Navigation = () => {
   const navigate = useNavigate();
   const [isMenuOpen, setIsMenuOpen] = useState(false);
   const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
   const [isNavVisible, setIsNavVisible] = useState(true);
   const [lastScrollY, setLastScrollY] = useState(0);
   const navRef = useRef(null);
   const jwt = Cookies.get("jwt");

   // Handle login button click
   const handleLogin = () => {
      // Always show coming soon modal
      setIsLoginModalOpen(true);
   };

   const handleAuthRedirect = (type) => {
      let baseUrl = process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";
      baseUrl = baseUrl.replace(/\/$/, "");
      baseUrl = baseUrl.replace(/\/api$/, "");
      window.location.href = `${baseUrl}/api/auth/google?userType=${type}`;
      setIsLoginModalOpen(false);
   };

   // Handle navigation links with hash routing
   const handleNavClick = (hash) => {
      setIsMenuOpen(false);

      setTimeout(() => {
         const section = document.getElementById(hash);
         if (section) {
            section.scrollIntoView({ behavior: "smooth", block: "start" });
         }
      }, 100);
   };

   // Handle Get Started button
   const handleGetStarted = () => {
      // Always show coming soon modal
      setIsLoginModalOpen(true);
   };

   const handleHomeClick = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
      setIsMenuOpen(false);
   };

   // Scroll-based hide/show for desktop navigation
   useEffect(() => {
      const handleScroll = () => {
         const currentScrollY = window.scrollY;
         const isDesktop = window.innerWidth > 768; // Desktop breakpoint

         // Add scrolled class for background
         if (navRef.current) {
            if (currentScrollY > 50) {
               navRef.current.classList.add('scrolled');
            } else {
               navRef.current.classList.remove('scrolled');
            }
         }

         if (isDesktop) {
            // Show navbar when scrolling up or at top
            if (currentScrollY < lastScrollY || currentScrollY < 100) {
               setIsNavVisible(true);
            }
            // Hide navbar when scrolling down
            else if (currentScrollY > lastScrollY && currentScrollY > 100) {
               setIsNavVisible(false);
            }
         } else {
            // Always show on mobile
            setIsNavVisible(true);
         }

         setLastScrollY(currentScrollY);
      };

      window.addEventListener('scroll', handleScroll, { passive: true });
      return () => window.removeEventListener('scroll', handleScroll);
   }, [lastScrollY]);

   return (
      <>
         {/* Top Navigation - Desktop */}
         <nav ref={navRef} className={`navigation ${!isNavVisible ? 'nav-hidden' : ''}`}>
            <div className="container">
               <div className="nav-content">
                  <div className="logo-container">
                     <img src="../webdpro.png" alt="Webdpro Logo" className="logo-main" />
                     <span className="logo-text">Webdpro</span>
                  </div>
                  <div className="nav-links">
                     <a href="#" className="nav-link" onClick={(e) => { e.preventDefault(); handleHomeClick(); }}>Home</a>
                     <a href="#serv" className="nav-link" onClick={(e) => { e.preventDefault(); handleNavClick('serv'); }}>Services</a>
                     <a href="#success-stories" className="nav-link" onClick={(e) => { e.preventDefault(); handleNavClick('success-stories'); }}>Success Stories</a>
                     <a href="#contact" className="nav-link" onClick={(e) => { e.preventDefault(); handleNavClick('contact'); }}>Contact</a>
                     <button onClick={handleLogin} className="nav-link btn-login">
                        {jwt ? "Dashboard" : "Login"}
                     </button>
                     <button onClick={handleGetStarted} className="nav-link btn-action">
                        Get Started
                     </button>
                  </div>
                  {/* Profile component only appears after login */}
                  {jwt && <Profile />}
                  <div className="mobile-menu-toggle" onClick={() => setIsMenuOpen(!isMenuOpen)}>
                     <span></span>
                     <span></span>
                     <span></span>
                  </div>
               </div>
            </div>
         </nav>

         {/* Side Panel - Mobile */}
         <div className={`nav-side-panel ${isMenuOpen ? "open" : ""}`}>
            <div className="mobile-menu-header">
               <div className="logo-container">
                  <img src="../webdpro.png" alt="Webdpro Logo" className="logo-main" />
                  <span className="logo-text">Webdpro</span>
               </div>
               <div className="close-menu" onClick={() => setIsMenuOpen(false)}>
                  ×
               </div>
            </div>
            <a href="#" className="nav-link" onClick={(e) => { e.preventDefault(); handleHomeClick(); setIsMenuOpen(false); }}>Home</a>
            <a href="#serv" className="nav-link" onClick={(e) => { e.preventDefault(); handleNavClick('serv'); }}>Services</a>
            <a href="#success-stories" className="nav-link" onClick={(e) => { e.preventDefault(); handleNavClick('success-stories'); }}>Success Stories</a>
            <a href="#contact" className="nav-link" onClick={(e) => { e.preventDefault(); handleNavClick('contact'); }}>Contact</a>
            <button
               onClick={() => {
                  handleLogin();
                  setIsMenuOpen(false);
               }}
               className="nav-link btn-login"
            >
               {jwt ? "Dashboard" : "Login"}
            </button>
            <button
               onClick={() => {
                  handleGetStarted();
                  setIsMenuOpen(false);
               }}
               className="nav-link btn-action"
            >
               Get Started
            </button>
            {/* Profile component in mobile menu */}
            <div className="mobile-profile-wrapper">
               {jwt && <Profile />}
            </div>
         </div>

         {isLoginModalOpen && (
            <div className="login-modal-overlay" onClick={() => setIsLoginModalOpen(false)}>
               <div className="login-modal" onClick={e => e.stopPropagation()}>
                  <div className="modal-header">
                     <h3>Coming Soon</h3>
                     <button className="close-btn" onClick={() => setIsLoginModalOpen(false)}>&times;</button>
                  </div>
                  <div className="modal-body">
                     <div className="coming-soon-container">
                        <div className="coming-soon-icon">
                           <i className="fas fa-rocket"></i>
                        </div>
                        <p className="coming-soon-message">
                           AI development coming soon. You will be able to login after AI service development is completed.
                        </p>
                     </div>
                  </div>
               </div>
            </div>
         )}
      </>
   );
};

export default Navigation;